
require("./../../node_modules/.pnpm/@module-federation+nextjs-mf@6.5.1_next@13.3.4_@babel+core@7.28.5_react-dom@18.2.0_react@18.2_p7m5rp5n5lfatnoefcyspw7key/node_modules/@module-federation/nextjs-mf/src/include-defaults.js");
import React, { useEffect } from 'react';
import { GetServerSideProps, NextPage } from 'next';
import dynamic from 'next/dynamic';
import { useDispatch } from 'react-redux';
import getServerSidePropsCommon from '~/src/lib/serverProps';
import { setReferralCode } from '~/src/redux/referral-lead/referral-lead.slice';
import { ProductsService } from '~/src/services/products.service';
import { OfferService } from '~/src/services/offer.service';
import { CmsService } from '~/src/services/cms.service';
import { useOrganizationsDispatch } from '~/src/hooks/use-organizations-dispatch.hook';
import { useSendInitAnalytics } from '~/src/hooks/use-send-init-analytics.hook';
import type { ProductsListItemInterface } from '~/src/repositories/products/products.repository';
import type { MainToolsBlockInterface } from '~/src/repositories/cms/entities/main/types/cms.main-tools-block.types';
import type { UpperBlockInterface } from '~/src/repositories/cms/entities/main/types/cms.upper-block.types';
import type { FaqListInterface } from '~/src/repositories/cms/entities/main/types/cms.faq-list.types';
import type { ReviewsAgentsInterface } from '~/src/repositories/cms/entities/main/types/cms.reviews-agents.types';
import type { TargetAudienceInterface } from '~/src/repositories/cms/entities/main/types/cms.target-audience.types';
import type { ServicesListInterface } from '~/src/repositories/cms/entities/main/types/cms.services-list.types';

const MainLandingLayout = dynamic(() => import('~/src/layouts/main-landing-layout/main-landing-layout'), {
    ssr: false,
});

export interface HomePageProps {
    productsData: ProductsListItemInterface[] | [];
    offerUrl: string;
    agentId: string | string[];
    faqData: FaqListInterface[] | [];
    reviewsAgentsData: ReviewsAgentsInterface[] | [];
    targetAudienceData: TargetAudienceInterface[] | [];
    servicesList: ServicesListInterface[] | [];
    upperBlockData: UpperBlockInterface[] | [];
    mainToolsBlockData: MainToolsBlockInterface[] | [];
}

const HomePage: NextPage<HomePageProps> = ({
    productsData,
    offerUrl,
    agentId,
    reviewsAgentsData,
    faqData,
    targetAudienceData,
    servicesList,
    upperBlockData,
    mainToolsBlockData,
}) => {
    const dispatch = useDispatch();
    useOrganizationsDispatch();
    useSendInitAnalytics();
    //TODO Задуматься о том чтобы вынести в redux upperBlockData

    useEffect(() => {
        if (agentId && typeof agentId === 'string') {
            dispatch(setReferralCode(agentId?.replace(/(")/g, '')));
        }
    }, [agentId]);

    return (
        <>
            <MainLandingLayout
                productsData={productsData}
                offerUrl={offerUrl}
                reviewsAgentsData={reviewsAgentsData}
                faqData={faqData}
                targetAudienceData={targetAudienceData}
                servicesList={servicesList}
                upperBlockData={upperBlockData}
                mainToolsBlockData={mainToolsBlockData}
            />
        </>
    );
};

export const getServerSideProps: GetServerSideProps = async ({ query }) => {
    const agentId = query?.agentId;
    const productsData = await ProductsService.getProductsList(true);
    const reviewsAgentsData = await CmsService.getReviewsAgents(true);
    const targetAudienceData = await CmsService.getTargetAudienceAgents(true);
    const faqData = await CmsService.getFaqList(true);
    const upperBlockData = await CmsService.getUpperBlockData(true);
    const { url: offerUrl = '' } = await OfferService.getOffer(true);
    const servicesList = await CmsService.getMtsServicesList(true);
    const mainToolsBlockData = await CmsService.getMainToolsBlockData(true);

    return {
        props: {
            ...(await getServerSidePropsCommon()),
            reviewsAgentsData: reviewsAgentsData || [],
            targetAudienceData: targetAudienceData || [],
            productsData: productsData || [],
            faqData: faqData || [],
            upperBlockData: upperBlockData || [],
            offerUrl,
            agentId: agentId || '',
            servicesList: servicesList || [],
            mainToolsBlockData: mainToolsBlockData || [],
            footerWithShadow: false,
        },
    };
};

export default HomePage;
